import classNames from 'classnames'
import SocialIcon from 'components/SocialIcon'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'
import './index.scss'

// const SOCIAL_TO_BACKGROUND_COLOR = {
//   facebook: '#3b5998',
//   twitter: '#00aced',
//   tumblr: '#34526f',
//   google: '#0266C8',
//   instagram: '#833AB4',
//   pinterest: '#e60023'
// }

class SocialButton extends React.Component {
  renderIcon () {
    return (
      <div
        style={{
          height: '2.77em',
          width: '2.77em',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <SocialIcon name={this.props.name} />
      </div>
    )
  }

  renderLabel () {
    if (!this.props.label) {
      return
    }
    return (
      <div
        style={{
          width: '11.11em'
        }}
      >
        {this.props.label}
      </div>
    )
  }

  render () {
    const className = classNames({
      socialButton: true,
      socialButton_background: true
    })
    return (
      <button
        className={className}
        onClick={this.props.onClick}
        disabled={this.props.disabled}
        style={{
          display: 'flex',
          color: STYLES_COLOR.WHITE,
          height: this.props.isFullHeight ? '100%' : '2.77em',
          width: this.props.isFullWidth ? '100%' : 'auto',
          borderRadius: '0.27em',
          overflow: 'hidden',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all .125s ease-in-out',
          cursor: 'pointer',
          backgroundColor: '#151D21'
          // backgroundColor: SOCIAL_TO_BACKGROUND_COLOR[this.props.name]
        }}
      >
        {this.renderIcon()}
        {this.renderLabel()}
      </button>
    )
  }
}

SocialButton.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isFullHeight: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  onClick: PropTypes.func
}

export default SocialButton
